export default {
  CruiseBookingContainer__DISCLAIMER: "Don’t let that cruise sail away!",
  CruiseBookingContainer__SEARCH_BUTTON: "Search cruises",
  CruiseBookingContainer__SEARCH_BUTTON_ARIA_LABEL:
    "Search cruises. Opens new window. External site which may or may not meet accessibility guidelines.",
};
